import React from 'react';

// ============================================================
// contexts/LangContext.js
// EV Powertrain Simulator — 언어 Context 단일 정의
// 패턴: Context (싱글톤 Context 객체 + 편의 훅)
// 사용법: import { LangContext, useLang } from '../../contexts/LangContext.js';
//
// 문제: 기존에 모든 탭·모달·shared 컴포넌트(총 28개 파일)에서
//       각자 React.createContext('ko')를 선언하고 있었음.
//       Context 객체의 identity가 파일마다 달라 버그 위험이 있었음.
//
// 해결: 이 파일을 단일 출처(Single Source of Truth)로 정의하고
//       모든 파일에서 여기서 import해서 사용.
//
// 사용법:
//   import { LangContext, useLang } from '../../contexts/LangContext.js';
//
// Provider는 최상위 EVSimulatorInner 에서 한 번만 선언:
//   <LangContext.Provider value={lang}>
//     ...
//   </LangContext.Provider>
// ============================================================

/**
 * 앱 전역 언어 설정을 공유하는 React Context 객체.
 *
 * 기본값 'ko'는 Provider 없이 useContext를 호출할 때의 폴백값으로,
 * 실제 앱 환경에서는 항상 EVSimulatorInner의 Provider를 통해 값을 제공한다.
 *
 * @type {React.Context<'ko'|'en'>}
 */
export const LangContext = React.createContext('ko');

/**
 * 현재 활성 언어 코드를 반환하는 편의 훅.
 *
 * LangContext.Provider가 제공하는 lang 값을 소비한다.
 * 'ko'(한국어) 또는 'en'(영어) 중 하나를 반환하며,
 * 컴포넌트 내에서 조건부 텍스트 렌더링에 사용한다.
 *
 * @returns {'ko'|'en'}  현재 언어 코드
 */
export const useLang = () => React.useContext(LangContext);
